module.exports = __webpack_public_path__ + "img/mobile-65.0c9f3ccd.png";